import React, { useState } from 'react'
import { EnumType } from 'json-to-graphql-query'
import classNames from 'classnames'
import Comment from '../../../Comment/index'
import CustomMultiSelect from '../../../Input/CustomMultiSelect'
import { Select } from '../../../../containers/CustomDashboardv2/Dashboard/details/editor/inputs/Select'
import { MetricInput } from '../../../../containers/CustomDashboardv2/Dashboard/details/editor/inputs/CustomChartInputs'
import { TIME_WINDOW_OPTIONS, CHART_COUNT_OPTIONS, AUDIENCE_OPTIONS } from '../../constants'
import { metricDevices } from '../../../../api/dashboard'
import { defaultNotifier } from 'functions/notificationHandler'
import { handleApiResponse } from '../../../../utils/request'

const AskVisoCreateCharts = ({
  metricsData = [], color, dashboardDetails, mode, isFullscreen, setPromptValue, setDashboardBuildingInput, isLoading
}) => {
  const [formValues, setFormValues] = useState({
    timeRange: TIME_WINDOW_OPTIONS.find(option => option.totalDays === 30),
    metrics: [],
    devices: [],
    audience: AUDIENCE_OPTIONS[0].value,
    chartCount: CHART_COUNT_OPTIONS[0].value,
    metricsTable: '',
    devices: []
  })
  const [deviceList, setDeviceList] = useState([])
  const [tableName, setTableName] = useState('')

  const loadDevices = async (metricsTable) => {
    if (metricsTable && tableName !== metricsTable) {
      const dashboardId = dashboardDetails?._id || dashboardDetails?.details?._id
      if (!dashboardId) return
      const onSuccess = (response) => {
        const buildDevices = response.length > 0 ? response.map(device => ({label: device.name, value: device._id})) : []
        setDeviceList(buildDevices)
        setTableName(metricsTable)
      }
      try {
        const metricDevicesData = await metricDevices({
          id: dashboardId,
          tableName: metricsTable
        })
        handleApiResponse(metricDevicesData, onSuccess, 'metricDevices')
      } catch (error) {
        defaultNotifier(error)
      }
    }
  }

  const handleChange = (value) => {
    value.metricsTable && loadDevices(value.metricsTable)
    const updateValues = { ...formValues, ...value }
    const metricNames = updateValues.metrics.map(metric => metric.label || metric.name || metric).join(', ');
    const promptValue = updateValues.metrics.length > 0 ? `Create ${updateValues.chartCount} chart(s), Include ${metricNames} as metric(s), Use ${updateValues.devices.length > 0 ? `${updateValues.devices.length} device(s)` : 'Dashboard default device(s)'}, focus on data over the last ${updateValues.timeRange.timeQuantity} ${updateValues.timeRange.timeInterval}, surface ${updateValues.audience} insights.` : ''
    setFormValues(updateValues)
    setPromptValue(promptValue)
    setDashboardBuildingInput(getBuildInput(promptValue))
  }

  const getBuildInput = (value) => {

    if (value) {
      let setTimeRange = { useDashboardDefault: true }

      if (formValues?.timeRange?.start) {
        if (formValues.timeRange.mode === 'relative') {
          setTimeRange = {
            useDashboardDefault: false,
            mode: new EnumType('relative'),
            relative: {
              unit: new EnumType(formValues.timeRange.timeInterval.toLowerCase()),
              value: Number(formValues.timeRange.timeQuantity)
            }
          }
        } else {
          setTimeRange = {
            useDashboardDefault: false,
            mode: new EnumType('absolute'),
            absolute: {
              start: formValues.timeRange.start,
              end: formValues.timeRange.end
            }
          }
        }
      }

      const dashboardId = dashboardDetails?._id || dashboardDetails?.details?._id
      const dashboardBuildingInput = {
        dashboardId,
        buildChartData: {
          devices: {
            ...(formValues.devices.length > 0 ? {
              value: formValues.devices,
              useDashboardDefault: false
            } : {
              useDashboardDefault: true
            }),
          },
          timeRange: setTimeRange,
          metrics: formValues.metrics.map(metric => metric.value),
          audience: formValues.audience,
          count: formValues.chartCount
        }
      }
      return dashboardBuildingInput
    }
  }

  if(isLoading) {
    return null
  }

  return (
    <div className={classNames('ask-viso-create-form', isFullscreen && 'ask-viso-create-form--fullscreen')}>
      <div className='ask-viso-create-form__content'>
        <Comment
          contentClass='ask-viso-chat__comment'
          showAvatar
          hideName
          firstName='A'
          lastName='I'
          color={color}
          text={
            <div className='ask-viso-create-form__form'>
              <div className='ask-viso-create-form__title'>Please provide additional information needed to {mode?.[0]?.label} for you.</div>
              <div className='border-left'>
                <Select
                  label='Chart Count'
                  selectedOption={CHART_COUNT_OPTIONS.find(option => option.value === formValues.chartCount)}
                  options={CHART_COUNT_OPTIONS}
                  onChange={(value) => handleChange({ chartCount: value.value })}
                />
                <MetricInput
                  id='metrics'
                  label='Metrics'
                  placeholder='Select'
                  selectedTableName={formValues.metricsTable}
                  selectedMetrics={formValues.metrics}
                  metricOptions={metricsData}
                  onChangeSelectedMetrics={(selectedOptions) => {
                    handleChange({ metrics: selectedOptions, metricsTable: selectedOptions[0] ? selectedOptions[0].tableName : '' })
                  }}
                  chartType={formValues.chartType}
                />
                <Select
                  label='Time Range'
                  withTimeRangeMenu
                  timeRangeOverflow='close'
                  timeRangeAlignment={isFullscreen ? 'start' : 'end'}
                  selectedOption={formValues.timeRange}
                  withDashboardDefault={false}
                  onChange={(value) => handleChange({ timeRange: value })}
                  options={TIME_WINDOW_OPTIONS}
                />

                <CustomMultiSelect
                  value={formValues.devices}
                  color={color}
                  onChange={(value) => handleChange({ devices: value })}
                  options={deviceList}
                  disabled={deviceList.length === 0}
                  label='Devices'
                  rectangularTags
                  borderInput
                  showAllOption='Dashboard default'
                />

                <Select
                  label='Audience'
                  selectedOption={AUDIENCE_OPTIONS.find(option => option.value === formValues.audience)}
                  options={AUDIENCE_OPTIONS}
                  onChange={(value) => handleChange({ audience: value.value })}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  )
}

export default AskVisoCreateCharts